import { useState, useEffect } from "react";
import PageHeader from "./PageHeader";
import Breadcrumb from "./Breadcrumb";
import getImageUrl from "./get-image-url.js";
import { Icon } from "@iconify/react";
import scrollIntoView from "scroll-into-view-if-needed";
import { useMediaQuery } from "react-responsive";
import ReactPlayer from "react-player/youtube";
import BtnText from "./BtnText.jsx";
import apiFetch from "@wordpress/api-fetch";
import parse from "html-react-parser";
import { AnimatePresence, motion } from "framer-motion";

const fadeInBottom = {
	hidden: {
		opacity: 0,
		y: 80,
	},
	visible: (i) => ({
		opacity: 1,
		y: 0,
		transition: {
			y: {
				duration: 1.3,
				ease: [0.165, 0.84, 0.44, 1],
				delay: i || 0,
			},
			opacity: {
				duration: 0.3,
				delay: i || 0,
			},
		},
	}),
};

const scr = (node, block = "start", bebavior = "smooth") => {
	scrollIntoView(node, {
		behavior: bebavior,
		scrollMode: "if-needed",
		block: block,
		inline: "start",
	});
};

const Btn = (props) => {
	const isPC = useMediaQuery({
		query: "(min-width: 1024px)",
	});

	return (
		<motion.div
			variants={fadeInBottom}
			initial="hidden"
			whileInView="visible"
			viewport={{
				once: true,
				amount: 0.5,
			}}
			custom={props.delay}
			className="btn-wrapper"
		>
			<a href={props.href} className="btn">
				<div className="icon">
					<img src={props.icon} alt="" />
				</div>
				<p>{props.children}</p>
				<Icon icon="ep:arrow-up" rotate={1} />
			</a>
			<style jsx>{`
        :global(.btn-wrapper) {
          font-size: 16px;
          width: 15.531rem;
          height: 15.531rem;
          aspect-ratio: 1/1;
        }
        .btn {
          background-color: #003475;
          box-shadow: 8px 8px 10px #00347566;
          border-radius: 999px;
          text-align: center;
          font-weight: 700;
          color: #ffffff;
          aspect-ratio: 1;
          cursor: url(getImageUrl('cursor-pointer.cur')), auto;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          transition: background-color 0.4s ease-out, transform 0.15s ease-out;
          transform: scale(1);
          gap: 0.6rem;
        }
        .btn:hover {
          background-color: #1b5fb4;
        }
        .btn:active {
          transform: scale(0.95);
        }
        .icon {
          display: flex;
          align-items: flex-end;
        }
        .icon img {
          max-height: 100%;
        }
        @media screen and (min-width: 1024px) {
          :global(.btn-wrapper) {
            font-size: min(calc(16vw / 19.2), 16px);
            width: 21.875em;
            height: 21.875em;
            aspect-ratio: 1/1;
          }
          .btn {
            background: #003475;
            box-shadow: 8px 8px 10px #00347566;
            border-radius: 999px;
            text-align: center;
            line-height: 1.25;
            color: #ffffff;
            width: 100%;
            height: auto;
            cursor: url(getImageUrl('cursor-pointer.cur')), auto;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 16px;
            font-size: 1.875em;
          }
          .icon {
            display: flex;
            align-items: flex-end;
            max-height: none;
            height: 4em;
          }
          .icon img {
            max-height: 100%;
          }
        }
      `}</style>
		</motion.div>
	);
};

const CompanyList = (props) => {
	return (
		<>
			<div>
				<dt>{props.label}</dt>
				<dd
					style={{
						whiteSpace: "pre-wrap",
						wordBreak: "break-all",
					}}
				>
					{props.children}
				</dd>
			</div>
			<style jsx>{`
        dl {
          font: normal normal bold calc(35vw / 7.5) Noto Sans JP;
        }
        div {
          display: flex;
          border-bottom: 1px solid #2964b6;
        }
        dt,
        dd {
          display: flex;
          padding: calc(18vw / 7.5) 0 calc(18vw / 7.5) calc(22vw / 7.5);
        }
        dt {
          background: #2964b6 0% 0% no-repeat padding-box;
          border: 2px solid #2964b6;
          color: #ffffff;
          max-width: calc(225vw / 7.5);
          width: 100%;

          border-bottom: 1px solid #fff;
        }
        dd {
          flex-grow: 1;
        }
        @media screen and (min-width: 1024px) {
          div {
            display: flex;
            border-bottom: 1px solid #2964b6;
          }
          dt,
          dd {
            display: flex;
            align-items: center;
            padding: 30px 38px;
          }
          dt {
            background: #2964b6 0% 0% no-repeat padding-box;
            border: 2px solid #2964b6;
            font: normal normal bold 20px/25px Noto Sans JP;
            font-weight: 700;
            color: #ffffff;
            max-width: 245px;
            width: 100%;

            border-bottom: 1px solid #fff;
          }
          dd {
            font: normal normal normal 20px/25px Noto Sans JP;
            flex-grow: 1;
          }
        }
      `}</style>
		</>
	);
};

const CompanyList2 = (props) => {
	return (
		<>
			<div>
				<dt>{props.label}</dt>
				<dd>{props.children}</dd>
			</div>
			<style jsx>{`
        div {
          display: flex;
          border-bottom: 1px solid #2964b6;
        }
        dl {
          border-top: 1px solid #2964b6;
        }
        dt,
        dd {
          display: flex;
          align-items: center;
          padding: calc(14vw / 7.5) calc(38vw / 7.5);
          font-size: min(calc(32vw / 7.5), 16px);
        }
        dt {
          flex-grow: 1;
        }
        dd {
          background: #2964b6 0% 0% no-repeat padding-box;
          border: 2px solid #2964b6;
          font-weight: 700;
          color: #ffffff;
          max-width: calc(172vw / 7.5);
          width: 100%;
          justify-content: center;

          border-bottom: 1px solid #fff;
        }
        @media screen and (min-width: 1024px) {
          div {
            display: flex;
            border-bottom: 1px solid #2964b6;
          }
          dt,
          dd {
            display: flex;
            align-items: center;
            padding: 24px 38px;
          }
          dt {
            font: normal normal normal 20px/25px Noto Sans JP;
            flex-grow: 1;
          }
          dd {
            background: #2964b6 0% 0% no-repeat padding-box;
            border: 2px solid #2964b6;
            font: normal normal bold 20px/25px Noto Sans JP;
            color: #ffffff;
            max-width: 245px;
            width: 100%;
            justify-content: center;

            border-bottom: 1px solid #fff;
          }
        }
      `}</style>
		</>
	);
};

const DownloadBtnaArea = ({ id, children }) => {
	const [file, setFile] = useState(null);

	useEffect(() => {
		apiFetch({
			path: `${import.meta.env.VITE_SITE_URL}/wp-json/wp/v2/media/${id}`,
		}).then((data) => {
			setFile(data["source_url"]);
		});
	}, []);

	const DownloadBtn = () => {
		return (
			<>
				<a
					href={file}
					target="_blank"
					rel="noreferrer"
					className="download-btn"
					download
				>
					ダウンロード
					<Icon icon="mdi:triangle" color="white" rotate={2} />
				</a>
				<style jsx>{`
          .download-btn {
            background: #2964b6 0% 0% no-repeat padding-box;
            border: 2px solid #2964b6;
            border-radius: 24px;
            display: flex;
            justify-content: center;
            gap: 4px;
            font: normal normal normal clamp(14px, calc(20px / 7.5), 18px) Noto Sans JP;
            color: #ffffff;
            padding: 0 24px;
            align-items: center;
            width: fit-content;
            margin-top: 8px;
          }
        `}</style>
			</>
		);
	};

	return (
		<>
			<div>
				{parse(children)}
				<br />
				{file ? <DownloadBtn /> : ""}
			</div>
			<style jsx>{`
        div :global(pre) {
          white-space: pre-wrap;
        }
      `}</style>
		</>
	);
};

const Bank = () => {
	return (
		<>
			<div>
				<div>
					三井住友銀行
					<br />
					みずほ銀行
					<br />
					りそな銀行
					<br />
					横浜銀行
					<br />
					静岡銀行北陸銀行
					<br />
					琉球銀行
					<br />
					きらぼし銀行
					<br />
					神奈川銀行
					<br />
					横浜信用金庫
					<br />
					湘南信用金庫
					<br />
					城南信用金庫
					<br />
					川崎信用金庫
					<br />
					商工組合中央金庫
				</div>
			</div>
			<style jsx>{`
         {
          /* .box {
          display: flex;
          flex-direction: column;
          gap: calc(15vw / 7.5);
          font: normal normal normal calc(35vw / 7.5) Noto Sans JP;
        }
        @media screen and (min-width: 1024px) {
          .box {
            display: flex;
            gap: 40px;
            font: normal normal normal 20px/34px Noto Sans JP;
          }
        } */
        }
      `}</style>
		</>
	);
};

const Business = () => {
	const isPC = useMediaQuery({
		query: "(min-width: 1024px)",
	});

	return isPC ? (
		<>
			解体工事：建物解体・内装解体・外構解体・その他解体
			<br />
			土木工事：外構工事・造成工事
		</>
	) : (
		<div>
			解体工事：建物解体・内装解体・外構解体・その他解体
			<br />
			<span className="inline-flex">
				<span>土木工事：</span>
				<span>
					外構工事
					<br />
					造成工事
				</span>
			</span>
		</div>
	);
};

const CompanyListContent = [
	{
		label: "会社名",
		content: "横浜総合建設株式会社",
	},
	{
		label: "代表者",
		content: "安西 伸司",
	},
	{
		label: "所在地",
		content: "〒244-0801 神奈川県横浜市戸塚区品濃町845-3",
	},
	{
		label: "作業場",
		content: "〒246-0026 神奈川県横浜市瀬谷区阿久和南三丁目23番27号",
	},
	{
		label: "TEL",
		content: "045-383-9240",
	},
	{
		label: "FAX",
		content: "045-383-9241",
	},
	{
		label: "設立",
		content: "2009年4月",
	},
	{
		label: "資本金",
		content: "2000万円",
	},
	{
		label: "従業員",
		content: "46名（作業員19名含む）",
	},
	{
		label: "事業内容",
		content: <Business />,
	},
	{
		label: "建設業許可",
		content: <DownloadBtnaArea />,
	},
	{
		label: "取引銀行",
		content: <Bank />,
	},
	{
		label: "加盟団体",
		content: "",
	},
];

const CompanyList2Content = [
	{ label: "安全衛生責任者", content: "15名" },
	{ label: "再教育安全衛生責任者", content: "1名" },
	{ label: "安全管理者", content: "2名" },
	{ label: "石綿作業主任者", content: "13名" },
	{ label: "石綿作業従事者", content: "6名" },
	{ label: "建築物石綿含有建材調査者", content: "10名" },
	{ label: "石綿使用建築物解体業務特別教育", content: "1名" },
	{ label: "フルハーネス型安全帯使用作業特別教育", content: "11名" },
	{ label: "足場の組立作業主任者", content: "9名" },
	{ label: "地山の掘削及び土止め支保工作業主任者", content: "8名" },
	{ label: "車両建設機械基礎", content: "1名" },
	{ label: "コンクリート造工作物の解体作業主任者", content: "6名" },
	{ label: "車両建設機械整地など", content: "6名" },
	{ label: "車両系建設機械（解体）運転", content: "5名" },
	{ label: "車両系建設機械（積込・運搬・掘削）運転", content: "2名" },
	{ label: "ガス溶接技能者", content: "5名" },
	{ label: "宅地建物取引士", content: "6名" },
	{ label: "建築物等の鉄骨組立作業主任者", content: "3名" },
	{ label: "高所作業者（10M未満）運転", content: "3名" },
	{ label: "小型移動式クレーン運転技能者", content: "3名" },
	{ label: "刈払機取扱作業者", content: "4名" },
	{ label: "玉掛け技能", content: "3名" },
	{ label: "自由研削といし取替業務資格", content: "4名" },
	{ label: "木造建築物解体指揮者", content: "5名" },
	{ label: "伐木等作業(小径木)資格", content: "3名" },
	{ label: "特定化学物質等作業主任者", content: "" },
	{ label: "酸素欠乏硫化水素危険作業", content: "" },
	{ label: "解体工事施工技師", content: "" },
	{ label: "HySPEED工法指定施工管理者", content: "" },
	{ label: "アーク溶接等の業務資格危険物取扱者", content: "" },
	{ label: "低圧電気(交流600V以下)取り扱い者", content: "" },
	{ label: "クレーン（５ｔ未満）運転者", content: "" },
	{ label: "建設用リフト運転者", content: "" },
	{ label: "締固用機械運転", content: "" },
	{ label: "第二種酸欠危険作業", content: "" },
	{ label: "チェーンソー取扱者", content: "" },
	{ label: "特別管理産業廃棄物管理責任者", content: "" },
	{ label: "フォークリフト運転者", content: "" },
	{ label: "土木工事の現場安全施工管理者", content: "" },
	{ label: "巻き上げ機運転", content: "" },
	{ label: "丸のこ等取扱い作業従事者", content: "" },
	{ label: "有機溶剤作業主任者", content: "" },
	{ label: "振動工具取扱い作業従事者", content: "" },
	{ label: "大型特殊自動車免許", content: "" },
	{ label: "施工管理者のための足場点検実務修了", content: "" },
	{ label: "特定粉塵作業", content: "" },
	{ label: "木造建築物組立等作業主任者", content: "" },
];

function Company() {
	const [more, setMore] = useState(false);
	const [list1, setList1] = useState([]);
	const [list2, setList2] = useState([]);
	const [banners, setBanners] = useState([]);

	useEffect(() => {
		apiFetch({
			path: `${import.meta.env.VITE_SITE_URL}/wp-json/myroutes/company/`,
		}).then((data) => {
			setList1(data["companylist1"]);
			setList2(data["companylist2"]);
			setBanners(data["banners"]);
		});

		const hash = window.location.hash;
		if (hash) {
			const node = document.querySelector(hash);
			setTimeout(() => {
				scr(node);
			}, 800);
		}

		window.addEventListener("hashchange", () => {
			const hash = window.location.hash;
			if (hash) {
				const node = document.querySelector(hash);
				setTimeout(() => {
					scr(node);
				}, 800);
			}
		});
	}, []);

	const isPC = useMediaQuery({
		query: "(min-width: 1024px)",
	});

	const handleMore = () => {
		setMore(!more);
		if (more) {
			const node = document.querySelector(".more-button");
			setTimeout(() => {
				scr(node, "center", "auto");
			}, 10);
		}
	};

	const childVariantsBg = {
		hidden: {
			backgroundColor: "#003475",
			scaleX: 0,
			originX: 0,
			width: "100%",
			height: "100%",
		},
		shown: {
			scaleX: [0, 1, 1, 0],
			originX: [0, 0, 1, 1],
			transition: {
				duration: 0.6,
			},
		},
	};

	return (
		<>
			<PageHeader image={getImageUrl("COMPANY.png")} title={"会社案内"} />
			<div className="content-area">
				<Breadcrumb
					current={"会社案内"}
					site_url={import.meta.env.VITE_SITE_URL}
					items={[]}
				/>
			</div>
			<div className="pt-[calc(86vw/7.5)] pb-[calc(110vw/7.5)] px-[calc(70vw/7.5)] lg:pt-[114px] lg:pb-[200px] lg:px-0">
				<motion.div
					variants={fadeInBottom}
					initial="hidden"
					whileInView="visible"
					viewport={{
						once: true,
						amount: 0.5,
					}}
				>
					<h2>施主様の立場で施工</h2>
				</motion.div>
				<motion.div
					variants={fadeInBottom}
					initial="hidden"
					whileInView="visible"
					viewport={{
						once: true,
						amount: 0.5,
					}}
				>
					<p className="paragrah-1 mt-[60px]">
						横浜総合建設株式会社は解体工事・土木工事を行っている会社です。
					</p>
					<p className="paragrah-1 mt-[1.25em]">
						営業スタッフは大半が不動産経験者で、工事を依頼する立場の仕事をしておりました。
						<br />
						この経験を活かし、工事を依頼する側の立場をよく理解したうえで日々営業活動及び現場管理を行っております。
						<br />
						特に近隣の方への配慮は得意としております。
					</p>
					<p className="paragrah-1 mt-[1.25em]">
						これからも常に「施主様」のお気持ちにたって工事を続けたいと考えております。
					</p>
				</motion.div>
			</div>
			<div id="philosophy" className="section-2">
				{isPC ? (
					<motion.div
						variants={fadeInBottom}
						initial="hidden"
						whileInView="visible"
						viewport={{
							once: true,
							amount: 0.5,
						}}
					>
						<div className="flex justify-center items-center gap-[70px] lg:px-3">
							<div className="max-[1280px]:max-w-[600px]">
								<h3>経営理念</h3>

								<img
									src={getImageUrl("company-philosophy.png")}
									alt=""
									className="mt-[50px]"
								/>
								<img
									src={getImageUrl("company-president-name.png")}
									alt=""
									className="ml-auto mt-[60px]"
								/>
							</div>

							<div className="w-fit max-[1280px]:max-w-[280px]">
								<img
									src={getImageUrl("company-president-image.png")}
									alt=""
									className="ml-auto"
								/>
							</div>
						</div>
					</motion.div>
				) : (
					<motion.div
						variants={fadeInBottom}
						initial="hidden"
						whileInView="visible"
						viewport={{
							once: true,
							amount: 0.5,
						}}
					>
						<div className="px-[calc(70vw/7.5)] grid justify-items-center">
							<h3 className="text-center">経営理念</h3>
							<img
								src={getImageUrl("company-philosophy.png")}
								alt=""
								className="mt-[calc(100vw/7.5)]"
							/>
							<img
								src={getImageUrl("company-president-name.png")}
								alt=""
								className="mt-[calc(110vw/7.5)] w-[calc(400vw/7.5)]"
							/>

							<div className="w-fit">
								<img
									src={
										isPC
											? getImageUrl("company-president-image.png")
											: getImageUrl("company-president-image-sp.png")
									}
									alt=""
									className="mt-[calc(110vw/7.5)]"
								/>
							</div>
						</div>
					</motion.div>
				)}
			</div>
			<motion.div
				className="relative"
				initial="hidden"
				whileInView="shown"
				viewport={{
					once: true,
					amount: 0.5,
				}}
			>
				<motion.img
					src={
						isPC
							? getImageUrl("company-image-1.png")
							: getImageUrl("company-image-1-sp.png")
					}
					variants={{
						hidden: { opacity: 0 },
						shown: {
							opacity: 1,
							transition: {
								delay: 0.55,
							},
						},
					}}
				/>
				<div className="absolute inset-0 m-auto w-full h-full">
					<motion.div variants={childVariantsBg}></motion.div>
				</div>
			</motion.div>
			<div className="pt-[calc(132vw/7.5)] pb-[calc(152vw/7.5)] lg:pt-[200px] lg:pb-[230px]">
				<motion.div
					variants={fadeInBottom}
					initial="hidden"
					whileInView="visible"
					viewport={{
						once: true,
						amount: 0.5,
					}}
				>
					<h2>選ばれる理由</h2>
				</motion.div>
				<div
					className={
						isPC
							? "flex justify-center gap-[70px] mt-[60px] px-3"
							: "grid justify-center gap-[calc(132vw/7.5)] mt-[calc(140vw/7.5)]"
					}
				>
					<Btn
						icon={getImageUrl("company-icon-1.png")}
						href={`${
							import.meta.env.VITE_SITE_URL
						}/reason-for-choosing/#reason-for-choosing-1`}
					>
						不動産経験者が
						<br />
						皆様の立場で
						<br />
						考える
					</Btn>
					<Btn
						icon={getImageUrl("company-icon-2.png")}
						href={`${
							import.meta.env.VITE_SITE_URL
						}/reason-for-choosing/#reason-for-choosing-2`}
						delay={0.3}
					>
						自社スタッフ・
						<br />
						重機中心による
						<br />
						安心施工
					</Btn>
					<Btn
						icon={getImageUrl("company-icon-3.png")}
						href={`${
							import.meta.env.VITE_SITE_URL
						}/reason-for-choosing/#reason-for-choosing-3`}
						delay={0.6}
					>
						柔軟で
						<br />
						スピーディーな
						<br />
						対応
					</Btn>
				</div>
			</div>
			<div className="section-4">
				<motion.div
					variants={fadeInBottom}
					initial="hidden"
					whileInView="visible"
					viewport={{
						once: true,
						amount: 0.5,
					}}
				>
					<h2>解体業者なら横浜総合建設</h2>
				</motion.div>
				<div className="content-area mt-[min(calc(40vw/7.5),20px)] lg:mt-[60px]">
					<div className="flex justify-center">
						<ReactPlayer
							url="https://www.youtube.com/watch?si=lmkeESi2t5xzAPxJ&v=-5BFbdhasVY&feature=youtu.be"
							className="aspect-video"
							width={"100%"}
							height={"100%"}
						/>
					</div>
				</div>
			</div>
			<div
				id="overview"
				className="pt-[calc(132vw/7.5)] pb-[calc(152vw/7.5)] lg:pt-[200px] lg:pb-[230px]"
			>
				<motion.div
					variants={fadeInBottom}
					initial="hidden"
					whileInView="visible"
					viewport={{
						once: true,
						amount: 0.5,
					}}
				>
					<h2>会社概要</h2>
				</motion.div>
				<div className="content-area">
					<motion.div
						variants={fadeInBottom}
						initial="hidden"
						whileInView="visible"
						viewport={{
							once: true,
							amount: 0.125,
						}}
					>
						<dl className="company-list mt-[60px]">
							{list1 ? (
								<>
									{list1.map((item, index) => {
										if (item["_type"] === "field") {
											return (
												<CompanyList key={index} label={item.crb_heading}>
													{item.crb_content}
												</CompanyList>
											);
										}
										if (item["_type"] === "download") {
											return (
												<CompanyList key={index} label="建設業許可">
													<div className="grid gap-4">
														{item.crb_permit.map((item, index) => (
															<DownloadBtnaArea key={index} id={item.file}>
																{item.label}
															</DownloadBtnaArea>
														))}
													</div>
												</CompanyList>
											);
										}
									})}
								</>
							) : (
								""
							)}
						</dl>
					</motion.div>
				</div>
			</div>
			<div id="access-map" className="section-6">
				<motion.div
					variants={fadeInBottom}
					initial="hidden"
					whileInView="visible"
					viewport={{
						once: true,
						amount: 0.5,
					}}
				>
					<h2>アクセスマップ</h2>
				</motion.div>
				<div className="mt-[60px]">
					<div className="content-area">
						<iframe
							src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1625.4111833107052!2d139.5559701!3d35.4344301!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60185a47b2e4101f%3A0x6a5b42ea7a6fdf67!2z5qiq5rWc57eP5ZCI5bu66Kit77yI5qCq77yJ!5e0!3m2!1sja!2sjp!4v1702862179790!5m2!1sja!2sjp"
							width="100%"
							height="100%"
							allowfullscreen=""
							loading="lazy"
							referrerpolicy="no-referrer-when-downgrade"
							style={{ aspectRatio: "2/1" }}
						></iframe>
					</div>
				</div>
			</div>
			<div
				id="eligible-person"
				className="pt-[calc(132vw/7.5)] pb-[calc(152vw/7.5)] lg:pt-[200px] lg:pb-[230px]"
			>
				<motion.div
					variants={fadeInBottom}
					initial="hidden"
					whileInView="visible"
					viewport={{
						once: true,
						amount: 0.5,
					}}
				>
					<h2>資格保有者</h2>
				</motion.div>
				<div className="mt-[60px]">
					<div className="content-area">
						<motion.div
							variants={fadeInBottom}
							initial="hidden"
							whileInView="visible"
							viewport={{
								once: true,
								amount: 0.125,
							}}
						>
							<dl className="company-list">
								{list2 ? (
									<>
										{more
											? list2.map((item, index) => {
													return (
														<CompanyList2 key={index} label={item.crb_heading}>
															{item.crb_content}
														</CompanyList2>
													);
											  })
											: list2.slice(0, 20).map((item, index) => {
													return (
														<CompanyList2 key={index} label={item.crb_heading}>
															{item.crb_content}
														</CompanyList2>
													);
											  })}
									</>
								) : (
									""
								)}
							</dl>
						</motion.div>
					</div>
				</div>
				<BtnText
					onClick={() => handleMore()}
					arrowRotate={more ? 0 : 2}
					className="mx-auto mt-[min(calc(60vw/7.5),60px)] md:mt-[100px] more-button"
				>
					{more ? "閉じる" : "もっと見る"}
				</BtnText>
			</div>
			<div
				id="recruitment-of-partner-companies"
				className="section-8 lg:!pb-[120px]"
			>
				<motion.div
					variants={fadeInBottom}
					initial="hidden"
					whileInView="visible"
					viewport={{
						once: true,
						amount: 0.5,
					}}
				>
					<h2>協力業者様募集</h2>
				</motion.div>
				<div className="content-area">
					<motion.div
						variants={fadeInBottom}
						initial="hidden"
						whileInView="visible"
						viewport={{
							once: true,
							amount: 0.5,
						}}
					>
						<div className="grid lg:flex lg:justify-center mt-[60px] gap-y-[calc(30vw/7.5)]">
							<img
								src={getImageUrl("company-image-2.png")}
								alt=""
								className="w-[calc(480vw/7.5)] lg:w-auto"
							/>
							<img
								src={getImageUrl("company-image-3.png")}
								alt=""
								className="w-[calc(480vw/7.5)] justify-self-end lg:w-auto"
							/>
						</div>
					</motion.div>
					<motion.div
						variants={fadeInBottom}
						initial="hidden"
						whileInView="visible"
						viewport={{
							once: true,
							amount: 0.5,
						}}
					>
						<p className="paragrah-2 mt-[80px]">解体工事業者様へ</p>
						<p className="paragrah-3 mt-[20px]">
							弊社は、旧来の元請けと下請けという関係でなく、
							{isPC && <br />}
							お互いが対等な関係で取引が出来ることが、大切だと考えております。
						</p>
						<p className="paragrah-4 mt-[36px]">
							現在、弊社では多数の解体工事受注に伴い、{isPC || <br />}
							協力業者様が手薄となっております。
							<br />
							事業拡大につき、協力して下さる解体業者様を{isPC || <br />}
							募集しております。
						</p>
					</motion.div>
					<motion.div
						variants={fadeInBottom}
						initial="hidden"
						whileInView="visible"
						viewport={{
							once: true,
							amount: 0.5,
						}}
					>
						<div className="flex justify-center mt-[min(calc(60vw/7.5),60px)] lg:mt-[110px]">
							<p className="text-[#2964B6] pargrah-5">■</p>

							<div>
								<p className="pargrah-5">
									協力会社登録希望の業者様は、
									<a
										href={
											import.meta.env.VITE_SITE_URL +
											"/recruitment-of-partner-companies/"
										}
										className=" font-bold text-[#2964B6] underline"
									>
										別途応募ページ
									</a>
									{isPC || <br />}
									・電話・FAX又は、mailで
									{isPC && <br />}
									ご連絡ください。
								</p>
								<p className="pargrah-6 mt-[24px]">
									〒244-0801 神奈川県横浜市戸塚区品濃町845-3
									<br />
									TEL:045-383-9240　FAX:045-383-9241
								</p>
							</div>
						</div>
					</motion.div>
					<motion.div
						variants={fadeInBottom}
						initial="hidden"
						whileInView="visible"
						viewport={{
							once: true,
							amount: 0.5,
						}}
					>
						<BtnText
							width="568"
							pcWidth="335"
							href={`${
								import.meta.env.VITE_SITE_URL
							}/recruitment-of-partner-companies/`}
							className="md:mt-[100px] mt-[min(calc(50vw/7.5),50px)] mx-auto"
						>
							協力業者様募集ページへ
						</BtnText>
					</motion.div>
				</div>
			</div>
			<div id="Initiatives" className="pt-[calc(132vw/7.5)] lg:pt-[120px]">
				<motion.div
					variants={fadeInBottom}
					initial="hidden"
					whileInView="visible"
					viewport={{
						once: true,
						amount: 0.5,
					}}
				>
					<h2>主な取り組み</h2>
				</motion.div>
				<motion.div
					variants={fadeInBottom}
					initial="hidden"
					whileInView="visible"
					viewport={{
						once: true,
						amount: 0.5,
					}}
				>
					<div className="mt-[60px]">
						<div className="content-area">
							<div className="grid grid-cols-2 md:grid-cols-4 iInitiatives gap-3 justify-center justify-items-center p-[calc(48vw/7.5)_calc(122vw/7.5)] lg:p-[calc(40vw/19.2)] items-center">
								{banners
									? banners.map((item, index) => (
											<a href={item.crb_banner_url} key={index}>
												<img src={item.crb_banner} alt="" />
											</a>
									  ))
									: ""}
							</div>
						</div>
					</div>
				</motion.div>
			</div>
			<style jsx>{`
        .iInitiatives {
          border: 2px solid #2964b6;
        }
        h2 {
          text-align: center;
          font-size: 1.563rem;
          font-weight: bold;
          color: #2964b6;
        }
        .paragrah-1 {
          font-size: 1.094rem;
        }
        .paragrah-2 {
          text-align: center;
          font-size: 1.25rem;
          font-weight: bold;
        }
        .paragrah-3 {
          text-align: center;
          font-size: 0.938rem;
        }
        .paragrah-4 {
          text-align: center;
          font-size: 0.906rem;
          font-weight: bold;
          color: #2964b6;
        }
        .pargrah-5 {
          font-size: 0.781rem;
        }
        .pargrah-6 {
          font-size: 0.875rem;
          font-weight: bold;
        }
        .section-3 {
          background: #f4fbff 0% 0% no-repeat padding-box;
          padding: 130px 0;
        }
        h3 {
          font: normal normal bold calc(50vw / 7.5) Noto Sans JP;
          color: #003475;
        }
        .section-2,
        .section-4,
        .section-6,
        .section-8 {
          background: #f4fbff 0% 0% no-repeat padding-box;
          padding: calc(86vw / 7.5) 0 calc(112vw / 7.5);
        }
        .company-list {
          border-top: 1px solid #2964b6;
        }
        .button {
          background: #003475 0% 0% no-repeat padding-box;
          border-radius: 6px;
          width: 335px;
          height: 70px;
          color: #fff;
          margin-left: auto;
          margin-right: auto;
          display: flex;
          text-align: center;
          justify-content: center;
          align-items: center;
          margin-top: 100px;
          position: relative;
          font: normal normal bold 20px/27px Noto Sans JP;
          border: 2px solid #003475;
          transition: background 0.4s ease;
        }
        .button:hover {
          background: #ffffff 0% 0% no-repeat padding-box;
          color: #003475;
        }
        @media (min-width: 1024px) {
          h2 {
            text-align: center;
            font: normal normal bold 80px/100px Noto Sans JP;
            color: #2964b6;
          }
          .paragrah-1 {
            text-align: center;
            font: normal normal normal max(19px, calc(24vw / 19.2)) Noto Sans JP;
          }
          .paragrah-2 {
            text-align: center;
            font: normal normal bold 30px/80px Noto Sans JP;
          }
          .paragrah-3 {
            text-align: center;
            font: normal normal normal 22px/40px Noto Sans JP;
          }
          .paragrah-4 {
            text-align: center;
            font: normal normal bold 26px/48px Noto Sans JP;
            color: #2964b6;
          }
          .pargrah-5 {
            font: normal normal normal 26px/40px Noto Sans JP;
          }
          .pargrah-6 {
            font: normal normal bold 26px/40px Noto Sans JP;
          }
          .section-3 {
            background: #f4fbff 0% 0% no-repeat padding-box;
            padding: 130px 0;
          }
          h3 {
            font: normal normal bold 44px/50px Noto Sans JP;
            color: #003475;
          }
          .section-2,
          .section-4,
          .section-6,
          .section-8 {
            background: #f4fbff 0% 0% no-repeat padding-box;
            padding: 205px 0 230px;
          }
          .company-list {
            border-top: 1px solid #2964b6;
          }
          .button {
            background: #003475 0% 0% no-repeat padding-box;
            border-radius: 6px;
            width: 335px;
            height: 70px;
            color: #fff;
            margin-left: auto;
            margin-right: auto;
            display: flex;
            text-align: center;
            justify-content: center;
            align-items: center;
            margin-top: 100px;
            position: relative;
            font: normal normal bold 20px/27px Noto Sans JP;
            border: 2px solid #003475;
            transition: background 0.4s ease;
          }
          .button:hover {
            background: #ffffff 0% 0% no-repeat padding-box;
            color: #003475;
          }
        }
      `}</style>
		</>
	);
}

export default Company;
